export const MainTabId = '#main';
export const PropertiesTabId = '#properties';
export const ReviewsTabId = '#reviews';
export const StatisticsTabId = '#statistics';
